import React, {useMemo} from "react";
import objectPath from "object-path";
// LayoutContext
import {useHtmlClassService} from "../_core/MetronicLayout";
// Import Layout components
import {HeaderFrontend} from "./header/HeaderFrontend";
import {HeaderMobile} from "./header-mobile/HeaderMobile";
import { makeStyles } from '@material-ui/core/styles';
import {Footer} from "./footer/Footer";
import {LayoutInit} from "./LayoutInit";
import {QuickPanel} from "./extras/offcanvas/QuickPanel";
import {QuickUser} from "./extras/offcanvas/QuickUser";
import {ScrollTop} from "./extras/ScrollTop";

export function Frontend({ children }) {
    const uiService = useHtmlClassService();
    const classes = useStyles();
    document.body.classList.remove('aside-enabled');
    document.body.classList.remove('aside-fixed');
    document.body.classList.remove('aside-minimize-hoverable');
     uiService.disableAside = true;

    var urlParams = new URLSearchParams(window.location.search);
    if(urlParams.has('app')){
        document.body.classList.add('hide-headers');
    }

    // Layout settings (cssClasses/cssAttributes)
    const layoutProps = useMemo(() => {
        console.log('inside Frontend layout');
        return {
            layoutConfig: uiService.config,
            selfLayout: objectPath.get(uiService.config, "self.layout"),
            asideDisplay: objectPath.get(uiService.config, "aside.self.display"),
            desktopHeaderDisplay: objectPath.get(
                uiService.config,
                "header.self.fixed.desktop"
            ),
            contentCssClasses: uiService.getClasses("content", true),
            contentContainerClasses: uiService.getClasses("content_container", true),
            contentExtended: objectPath.get(uiService.config, "content.extended")
        };
    }, [uiService]);

    layoutProps.asideDisplay = false;

    return layoutProps.selfLayout !== "blank" ? (
        <>
            {/*begin::Main*/}
            <HeaderMobile/>
            <div className="d-flex flex-column flex-root">
                {/*begin::Page*/}
                <div className="d-flex flex-row flex-column-fluid page">
                    {/*begin::Wrapper*/}
                    <div className={`d-flex flex-column flex-row-fluid wrapper ${ classes.portalBg}`} id="kt_wrapper">
                        <HeaderFrontend/>
                        {/*begin::Content*/}
                        <div
                            id="kt_content"
                            className={`content ${layoutProps.contentCssClasses} d-flex flex-column flex-column-fluid`}
                        >
                            {/* {layoutProps.subheaderDisplay && <SubHeader/>} */}
                            {/*begin::Entry*/}
                            {!layoutProps.contentExtended && (
                                <div className="d-flex flex-column-fluid">
                                    {/*begin::Container*/}

                                    <div className={` ${layoutProps.contentContainerClasses} container-frontend `}>
                                        {children}
                                    </div>
                                    {/*end::Container*/}
                                </div>
                            )}

                            {layoutProps.contentExtended && {children}}
                            {/*end::Entry*/}
                        </div>
                        {/*end::Content*/}
                        <Footer/>
                    </div>
                    {/*end::Wrapper*/}
                </div>
                {/*end::Page*/}
            </div>
            <QuickUser/>
            <QuickPanel/>
            <ScrollTop/>
            {/* <StickyToolbar/> */}
            {/*end::Main*/}
            <LayoutInit />
        </>
    ) : (
        // BLANK LAYOUT
        <div className="d-flex flex-column flex-root">{children}</div>
    );
}

const useStyles = makeStyles((theme) => ({
    portalBg: {
        background: "#ffffff",
    }
}));
